export const organisationDevicesUrl = (domain, id, status) => {
  const base = `${domain}monitoring/devices/${id == null ? "" : `${encodeURIComponent(id)}/`}`;
  if (id != null || !status || status === "All") return base;
  return `${base}?${new URLSearchParams({ status: status.toUpperCase() })}`;
};

export const organisationDeviceFetchUrl = (domain, deviceId) =>
  `${domain}monitoring/devices/fetch/?${new URLSearchParams({ device_id: String(deviceId).trim() })}`;

export const organisationDeviceDeactivateUrl = (domain, id) =>
  `${domain}monitoring/devices/${encodeURIComponent(id)}/deactivate/`;

export const organisationDeviceReactivateUrl = (domain, id) =>
  `${domain}monitoring/devices/${encodeURIComponent(id)}/reactivate/`;

// Status filter options for the Devices list.
export const DEVICE_STATUS_FILTERS = ["All", "Active", "Inactive"];

const modes = { IN: "In Only", OUT: "Out Only", "BI-DIRECTIONAL": "Bi-Directional" };
export const API_DEVICE_MODES = Object.values(modes);

export const mapDeviceLookup = (data, deviceId) => {
  if (data?.found === false) return { status: "notFound" };
  const mode = modes[data?.detected_device_mode];
  if (data?.found !== true || String(data.device_id) !== String(deviceId).trim() || !mode) return { status: "unavailable" };
  return {
    status: "found", mode,
    serialNumber: data.serialnumber ?? "",
    location: data.devicelocation ?? "",
    direction: data.devicedirection ?? "",
    name: data.server_device_name ?? "",
  };
};

export const mapOrganisationDevice = row => ({
  id: row.id,
  name: row.device_name ?? "",
  code: row.device_id ?? "",
  serialNumber: row.serial_number ?? "",
  type: row.device_type ?? "",
  purpose: row.device_type ?? "Attendance",
  mode: modes[row.device_mode] || row.device_mode,
  location: row.location ?? "",
  active: row.status === "ACTIVE",
  status: row.is_online === true ? "Online" : row.is_online === false ? "Offline" : "Unknown",
  company: row.company_name ?? "",
  lastSync: row.last_seen ?? "",
  // History, not current-state fields: Reactivate keeps the last
  // deactivation (deactivated*) in place rather than clearing it, so these
  // can be populated even while active === true (it just means the device
  // was deactivated at some point and has since been reactivated).
  deactivatedAt: row.deactivated_at ?? null,
  deactivatedBy: row.deactivated_by ?? null,
  deactivationReason: row.deactivation_reason ?? null,
  reactivatedAt: row.reactivated_at ?? null,
  reactivatedBy: row.reactivated_by ?? null,
});

// Add/Edit Device: status is never part of this payload. Active/Inactive
// changes only through the dedicated Deactivate/Reactivate actions.
export const organisationDevicePayload = draft => {
  const deviceMode = Object.keys(modes).find(key => modes[key] === draft.mode);
  if (!deviceMode) throw new Error("Select a valid device mode.");
  return {
    device_id: String(draft.deviceId).trim(),
    device_mode: deviceMode,
    device_name: draft.name.trim(),
    device_type: draft.purpose,
    location: String(draft.location || "").trim(),
  };
};
